// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination__3N3po"};